import {
  GET_INVOICE_LIST,
  GET_INVOICE_LIST_SUCCESS,
  GET_INVOICE_LIST_ERROR,
  GET_INVOICE_STATUS_LIST,
  GET_INVOICE_STATUS_LIST_SUCCESS,
  GET_INVOICE_STATUS_LIST_ERROR,
  GET_INVOICE_SINGLE_PDF,
  GET_INVOICE_SINGLE_PDF_SUCCESS,
  GET_INVOICE_SINGLE_PDF_ERROR,
  GET_SINGLE_INVOICE_DATA,
  GET_SINGLE_INVOICE_DATA_SUCCESS,
  GET_SINGLE_INVOICE_DATA_ERROR,
  CREATE_SINGLE_INVOICE_DATA,
  CREATE_SINGLE_INVOICE_DATA_SUCCESS,
  CREATE_SINGLE_INVOICE_DATA_ERROR,
  UPDATE_SINGLE_INVOICE_DATA,
  UPDATE_SINGLE_INVOICE_DATA_SUCCESS,
  UPDATE_SINGLE_INVOICE_DATA_ERROR,
  SEARCH_SINGLE_CUSTOMER_INVOICE_LIST,
  SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_ERROR,
  SEARCH_JOB_INVOICE_LIST,
  SEARCH_JOB_INVOICE_LIST_SUCCESS,
  SEARCH_JOB_INVOICE_LIST_ERROR,
  RESEND_INVOICE_EMAIL,
  RESEND_INVOICE_EMAIL_SUCCESS,
  RESEND_INVOICE_EMAIL_ERROR,
  SEND_INVOICE_EMAIL,
  SEND_INVOICE_EMAIL_SUCCESS,
  SEND_INVOICE_EMAIL_ERROR,
  VOID_INVOICE,
  VOID_INVOICE_SUCCESS,
  VOID_INVOICE_ERROR,
  REINVOICE,
  REINVOICE_SUCCESS,
  REINVOICE_ERROR,
  ADD_NEW_INVOICE_STATUS,
  ADD_NEW_INVOICE_STATUS_SUCCESS,
  ADD_NEW_INVOICE_STATUS_ERROR,
  DELETE_INVOICE_STATUS,
  DELETE_INVOICE_STATUS_SUCCESS,
  DELETE_INVOICE_STATUS_ERROR,
  UPDATE_INVOICE_STATUS,
  UPDATE_INVOICE_STATUS_SUCCESS,
  UPDATE_INVOICE_STATUS_ERROR,
  GET_INVOICE_PAYMENT_METHOD_LIST,
  GET_INVOICE_PAYMENT_METHOD_LIST_SUCCESS,
  GET_INVOICE_PAYMENT_METHOD_LIST_ERROR,
  ADD_NEW_INVOICE_PAYMENT_METHOD,
  ADD_NEW_INVOICE_PAYMENT_METHOD_SUCCESS,
  ADD_NEW_INVOICE_PAYMENT_METHOD_ERROR,
  DELETE_INVOICE_PAYMENT_METHOD,
  DELETE_INVOICE_PAYMENT_METHOD_SUCCESS,
  DELETE_INVOICE_PAYMENT_METHOD_ERROR,
  UPDATE_INVOICE_PAYMENT_METHOD,
  UPDATE_INVOICE_PAYMENT_METHOD_SUCCESS,
  UPDATE_INVOICE_PAYMENT_METHOD_ERROR,
  GET_MASTER_INVOICE_LIST,
  GET_MASTER_INVOICE_LIST_SUCCESS,
  GET_MASTER_INVOICE_LIST_ERROR,
  GET_MASTER_INVOICE_SINGLE_DATA,
  GET_MASTER_INVOICE_SINGLE_DATA_SUCCESS,
  GET_MASTER_INVOICE_SINGLE_DATA_ERROR,
  GET_CRMIT_INVOICE_PDF_SINGLE,
  GET_CRMIT_INVOICE_PDF_SINGLE_SUCCESS,
  GET_CRMIT_INVOICE_PDF_SINGLE_ERROR,
  GET_INVOICE_ITEM_LIST,
  GET_INVOICE_ITEM_LIST_SUCCESS,
  GET_INVOICE_ITEM_LIST_ERROR,
  GET_MASTER_INVOICE_LIST_CUSTOMER,
  GET_MASTER_INVOICE_LIST_CUSTOMER_SUCCESS,
  GET_MASTER_INVOICE_LIST_CUSTOMER_ERROR,
  SEARCH_INVOICE_ACTIVITY_LOG,
  SEARCH_INVOICE_ACTIVITY_LOG_SUCCESS,
  SEARCH_INVOICE_ACTIVITY_LOG_ERROR,
  SEARCH_INVOICE_ITEMS_LIST,
  SEARCH_INVOICE_ITEMS_LIST_SUCCESS,
  SEARCH_INVOICE_ITEMS_LIST_ERROR,
  GET_JOB_INVOICE_ITEM_TEMPLATE_LIST,
  GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_SUCCESS,
  GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_ERROR,
  GET_JOB_INVOICE_ITEM_TEMPLATE_DATA,
  GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_SUCCESS,
  GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_ERROR,
  SEARCH_JOB_INVOICE_ITEM_TEMPLATE,
  SEARCH_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  SEARCH_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  CREATE_JOB_INVOICE_ITEM_TEMPLATE,
  CREATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  CREATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  UPDATE_JOB_INVOICE_ITEM_TEMPLATE,
  UPDATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  UPDATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  DELETE_JOB_INVOICE_ITEM_TEMPLATE,
  DELETE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  DELETE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
} from "./actionType";

const INIT_STATE = {
  invoiceList: [],
  InvoiceSinglePdf: [],
  singleInvoiceData: [],
  singleInvoiceDataLoading: false,
  singleCustomerInvoiceList: [],
  jobInvoiceList: [],
  jobInvoiceListLoaded: false,
  singleInvoiceCreateSuccess: [],
  resendInvoiceEmailSuccess: [],
  sendInvoiceEmailSuccess: [],
  singleInvoiceUpdateSuccess: [],
  loading: false,
  error: "",
  singleCustomerInvoiceListLoaded: false,
  voidInvoiceSuccess: [],
  reinvoiceSuccess: [],
  invoiceStatusList: [],
  addInvoiceStatusSuccess: [],
  deleteInvoiceStatusSuccess: [],
  updateInvoiceStatusSuccess: [],
  invoicePaymentMethodList: [],
  addInvoicePaymentMethodSuccess: [],
  deleteInvoicePaymentMethodSuccess: [],
  updateInvoicePaymentMethodSuccess: [],
  masterInvoiceList: [],
  masterInvoiceListLoading: false,
  masterInvoiceSingleData: [],
  masterInvoiceSingleDataLoading: false,
  crmitInvoiceSinglePdf: [],
  crmitInvoiceSinglePdfLoading: false,
  invoiceItemList: [],
  invoiceItemListLoading: false,
  masterInvoiceListCustomer: [],
  masterInvoiceListCustomerLoading: false,
  masterInvoiceListCustomerError: "",
  invoiceActivityLog: [],
  invoiceActivityLogLoading: false,
  invoiceItemsList: [],
  invoiceItemsListLoading: false,

  invoiceItemTemplateList: [],
  invoiceItemTemplateListLoading: false,

  invoiceItemTemplateData: [],
  invoiceItemTemplateDataLoading: false,

  searchInvoiceItemTemplate: [],
  searchInvoiceItemTemplateLoading: false,

  createInvoiceItemTemplate: [],
  createInvoiceItemTemplateLoading: false,

  updateInvoiceItemTemplate: [],
  updateInvoiceItemTemplateLoading: false,

  deleteInvoiceItemTemplate: [],
  deleteInvoiceItemTemplateLoading: false,
};

const InvoiceCrmIT = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_INVOICE_LIST:
      return { ...state, loading: true };

    case GET_INVOICE_LIST_SUCCESS:
      return { ...state, loading: false, invoiceList: action.payload };

    case GET_INVOICE_LIST_ERROR:
      return { ...state, loading: false, invoiceList: [] };

    case GET_INVOICE_STATUS_LIST:
      return { ...state };

    case GET_INVOICE_STATUS_LIST_SUCCESS:
      return { ...state, invoiceStatusList: action.payload };

    case GET_INVOICE_STATUS_LIST_ERROR:
      return { ...state, invoiceStatusList: [] };

    case GET_INVOICE_SINGLE_PDF:
      return { ...state, invoice: action.payload };

    case GET_INVOICE_SINGLE_PDF_SUCCESS:
      return { ...state, InvoiceSinglePdf: action.payload };

    case GET_INVOICE_SINGLE_PDF_ERROR:
      return { ...state, InvoiceSinglePdf: [] };

    case GET_SINGLE_INVOICE_DATA:
      return {
        ...state,
        invoice: action.payload,
        singleInvoiceDataLoading: true,
      };

    case GET_SINGLE_INVOICE_DATA_SUCCESS:
      return {
        ...state,
        singleInvoiceData: action.payload,
        singleInvoiceDataLoading: false,
      };

    case GET_SINGLE_INVOICE_DATA_ERROR:
      return {
        ...state,
        singleInvoiceData: [],
        singleInvoiceDataLoading: false,
      };

    case CREATE_SINGLE_INVOICE_DATA:
      return { ...state, invoice: action.payload };

    case CREATE_SINGLE_INVOICE_DATA_SUCCESS:
      return { ...state, singleInvoiceCreateSuccess: action.payload };

    case CREATE_SINGLE_INVOICE_DATA_ERROR:
      return { ...state, singleInvoiceData: [] };

    case UPDATE_SINGLE_INVOICE_DATA:
      return { ...state, invoice: action.payload };

    case UPDATE_SINGLE_INVOICE_DATA_SUCCESS:
      return { ...state, singleInvoiceUpdateSuccess: action.payload };

    case UPDATE_SINGLE_INVOICE_DATA_ERROR:
      return { ...state, singleInvoiceData: [] };

    case SEARCH_SINGLE_CUSTOMER_INVOICE_LIST:
      return { ...state, singleCustomerInvoiceListLoaded: true };

    case SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        singleCustomerInvoiceList: action.payload,
        singleCustomerInvoiceListLoaded: false,
      };

    case SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_ERROR:
      return {
        ...state,
        singleCustomerInvoiceList: [],
        singleCustomerInvoiceListLoaded: false,
      };

    case SEARCH_JOB_INVOICE_LIST:
      return { ...state, jobInvoiceListLoaded: true };

    case SEARCH_JOB_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        jobInvoiceList: action.payload,
        jobInvoiceListLoaded: false,
      };

    case SEARCH_JOB_INVOICE_LIST_ERROR:
      return {
        ...state,
        jobInvoiceList: [],
        jobInvoiceListLoaded: false,
      };

    case RESEND_INVOICE_EMAIL:
      return { ...state };

    case RESEND_INVOICE_EMAIL_SUCCESS:
      return { ...state, resendInvoiceEmailSuccess: action.payload };

    case RESEND_INVOICE_EMAIL_ERROR:
      return { ...state, resendInvoiceEmailSuccess: [] };

    case SEND_INVOICE_EMAIL:
      return { ...state };

    case SEND_INVOICE_EMAIL_SUCCESS:
      return { ...state, sendInvoiceEmailSuccess: action.payload };

    case SEND_INVOICE_EMAIL_ERROR:
      return { ...state, sendInvoiceEmailSuccess: [] };

    case VOID_INVOICE:
      return { ...state };

    case VOID_INVOICE_SUCCESS:
      return { ...state, voidInvoiceSuccess: action.payload };

    case VOID_INVOICE_ERROR:
      return { ...state, voidInvoiceSuccess: [] };

    case REINVOICE:
      return { ...state };

    case REINVOICE_SUCCESS:
      return { ...state, reinvoiceSuccess: action.payload };

    case REINVOICE_ERROR:
      return { ...state, reinvoiceSuccess: [] };

    case ADD_NEW_INVOICE_STATUS:
      return { ...state };

    case ADD_NEW_INVOICE_STATUS_SUCCESS:
      return { ...state, addInvoiceStatusSuccess: action.payload };

    case ADD_NEW_INVOICE_STATUS_ERROR:
      return { ...state, addInvoiceStatusSuccess: action.payload };

    case DELETE_INVOICE_STATUS:
      return { ...state };

    case DELETE_INVOICE_STATUS_SUCCESS:
      return { ...state, deleteInvoiceStatusSuccess: action.payload };

    case DELETE_INVOICE_STATUS_ERROR:
      return { ...state, deleteInvoiceStatusSuccess: action.payload };

    case UPDATE_INVOICE_STATUS:
      return { ...state };

    case UPDATE_INVOICE_STATUS_SUCCESS:
      return { ...state, updateInvoiceStatusSuccess: action.payload };

    case UPDATE_INVOICE_STATUS_ERROR:
      return { ...state, updateInvoiceStatusSuccess: action.payload };

    case GET_INVOICE_PAYMENT_METHOD_LIST:
      return { ...state };

    case GET_INVOICE_PAYMENT_METHOD_LIST_SUCCESS:
      return { ...state, invoicePaymentMethodList: action.payload };

    case GET_INVOICE_PAYMENT_METHOD_LIST_ERROR:
      return { ...state, invoicePaymentMethodList: action.payload };

    case ADD_NEW_INVOICE_PAYMENT_METHOD:
      return { ...state };

    case ADD_NEW_INVOICE_PAYMENT_METHOD_SUCCESS:
      return { ...state, addInvoicePaymentMethodSuccess: action.payload };

    case ADD_NEW_INVOICE_PAYMENT_METHOD_ERROR:
      return { ...state, addInvoicePaymentMethodSuccess: action.payload };

    case DELETE_INVOICE_PAYMENT_METHOD:
      return { ...state };

    case DELETE_INVOICE_PAYMENT_METHOD_SUCCESS:
      return { ...state, deleteInvoicePaymentMethodSuccess: action.payload };

    case DELETE_INVOICE_PAYMENT_METHOD_ERROR:
      return { ...state, deleteInvoicePaymentMethodSuccess: action.payload };

    case UPDATE_INVOICE_PAYMENT_METHOD:
      return { ...state };

    case UPDATE_INVOICE_PAYMENT_METHOD_SUCCESS:
      return { ...state, updateInvoicePaymentMethodSuccess: action.payload };

    case UPDATE_INVOICE_PAYMENT_METHOD_ERROR:
      return { ...state, updateInvoicePaymentMethodSuccess: action.payload };

    case GET_MASTER_INVOICE_LIST:
      return { ...state, masterInvoiceListLoading: true };

    case GET_MASTER_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        masterInvoiceListLoading: false,
        masterInvoiceList: action.payload,
      };

    case GET_MASTER_INVOICE_LIST_ERROR:
      return {
        ...state,
        masterInvoiceListLoading: false,
        masterInvoiceList: [],
      };

    case GET_MASTER_INVOICE_SINGLE_DATA:
      return { ...state, masterInvoiceSingleDataLoading: true };

    case GET_MASTER_INVOICE_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        masterInvoiceSingleDataLoading: false,
        masterInvoiceSingleData: action.payload,
      };

    case GET_MASTER_INVOICE_SINGLE_DATA_ERROR:
      return {
        ...state,
        masterInvoiceSingleDataLoading: false,
        masterInvoiceSingleData: [],
      };
    case GET_CRMIT_INVOICE_PDF_SINGLE:
      return { ...state, crmitInvoiceSinglePdfLoading: true };
    case GET_CRMIT_INVOICE_PDF_SINGLE_SUCCESS:
      return {
        ...state,
        crmitInvoiceSinglePdfLoading: false,
        crmitInvoiceSinglePdf: action.payload,
      };
    case GET_CRMIT_INVOICE_PDF_SINGLE_ERROR:
      return {
        ...state,
        crmitInvoiceSinglePdfLoading: false,
        crmitInvoiceSinglePdf: [],
      };
    case GET_INVOICE_ITEM_LIST:
      return { ...state, invoiceItemListLoading: true };
    case GET_INVOICE_ITEM_LIST_SUCCESS:
      return {
        ...state,
        invoiceItemListLoading: false,
        invoiceItemList: action.payload,
      };
    case GET_INVOICE_ITEM_LIST_ERROR:
      return {
        ...state,
        invoiceItemListLoading: false,
        invoiceItemList: [],
      };
    case GET_MASTER_INVOICE_LIST_CUSTOMER:
      return { ...state, masterInvoiceListCustomerLoading: true };
    case GET_MASTER_INVOICE_LIST_CUSTOMER_SUCCESS:
      return {
        ...state,
        masterInvoiceListCustomerLoading: false,
        masterInvoiceListCustomer: action.payload,
      };
    case GET_MASTER_INVOICE_LIST_CUSTOMER_ERROR:
      return {
        ...state,
        masterInvoiceListCustomerLoading: false,
        masterInvoiceListCustomer: [],
        masterInvoiceListCustomerError: action.payload,
      };
    case SEARCH_INVOICE_ACTIVITY_LOG:
      return { ...state, invoiceActivityLogLoading: true };
    case SEARCH_INVOICE_ACTIVITY_LOG_SUCCESS:
      return {
        ...state,
        invoiceActivityLogLoading: false,
        invoiceActivityLog: action.payload,
      };
    case SEARCH_INVOICE_ACTIVITY_LOG_ERROR:
      return {
        ...state,
        invoiceActivityLogLoading: false,
        invoiceActivityLog: [],
      };
    case SEARCH_INVOICE_ITEMS_LIST:
      return { ...state, invoiceItemsListLoading: true };
    case SEARCH_INVOICE_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        invoiceItemsListLoading: false,
        invoiceItemList: action.payload,
      };
    case SEARCH_INVOICE_ITEMS_LIST_ERROR:
      return {
        ...state,
        invoiceItemsListLoading: false,
        invoiceItemList: [],
      };
    case GET_JOB_INVOICE_ITEM_TEMPLATE_LIST:
      return { ...state, invoiceItemTemplateListLoading: true };
    case GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        invoiceItemTemplateListLoading: false,
        invoiceItemTemplateList: action.payload,
      };
    case GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_ERROR:
      return {
        ...state,
        invoiceItemTemplateListLoading: false,
        invoiceItemTemplateList: [],
      };
    case GET_JOB_INVOICE_ITEM_TEMPLATE_DATA:
      return { ...state, invoiceItemTemplateDataLoading: true };
    case GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        invoiceItemTemplateDataLoading: false,
        invoiceItemTemplateData: action.payload,
      };
    case GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_ERROR:
      return {
        ...state,
        invoiceItemTemplateDataLoading: false,
        invoiceItemTemplateData: [],
      };
    case SEARCH_JOB_INVOICE_ITEM_TEMPLATE:
      return { ...state, searchInvoiceItemTemplateLoading: true };
    case SEARCH_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS:
      return {
        ...state,
        searchInvoiceItemTemplateLoading: false,
        searchInvoiceItemTemplate: action.payload,
      };
    case SEARCH_JOB_INVOICE_ITEM_TEMPLATE_ERROR:
      return {
        ...state,
        searchInvoiceItemTemplateLoading: false,
        searchInvoiceItemTemplate: [],
      };
    case CREATE_JOB_INVOICE_ITEM_TEMPLATE:
      return { ...state, createInvoiceItemTemplateLoading: true };
    case CREATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS:
      return {
        ...state,
        createInvoiceItemTemplateLoading: false,
        createInvoiceItemTemplate: action.payload,
      };
    case CREATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR:
      return {
        ...state,
        createInvoiceItemTemplateLoading: false,
        createInvoiceItemTemplate: [],
      };
    case UPDATE_JOB_INVOICE_ITEM_TEMPLATE:
      return { ...state, updateInvoiceItemTemplateLoading: true };
    case UPDATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS:
      return {
        ...state,
        updateInvoiceItemTemplateLoading: false,
        updateInvoiceItemTemplate: action.payload,
      };
    case UPDATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR:
      return {
        ...state,
        updateInvoiceItemTemplateLoading: false,
        updateInvoiceItemTemplate: [],
      };
    case DELETE_JOB_INVOICE_ITEM_TEMPLATE:
      return { ...state, deleteInvoiceItemTemplateLoading: true };
    case DELETE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteInvoiceItemTemplateLoading: false,
        deleteInvoiceItemTemplate: action.payload,
      };
    case DELETE_JOB_INVOICE_ITEM_TEMPLATE_ERROR:
      return {
        ...state,
        deleteInvoiceItemTemplateLoading: false,
        deleteInvoiceItemTemplate: [],
      };

    default:
      return { ...state };
  }
};

export default InvoiceCrmIT;
